import { render } from "./Paradigm.vue?vue&type=template&id=6af44f68&scoped=true&ts=true"
import script from "./Paradigm.vue?vue&type=script&lang=ts"
export * from "./Paradigm.vue?vue&type=script&lang=ts"

import "./Paradigm.vue?vue&type=style&index=0&id=6af44f68&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af44f68"]])

export default __exports__